import React from "react";
import PropTypes from "prop-types";
import { Field } from "redux-form";
import { connect } from "react-redux";
import { form, Form as AppForm, Select } from "MODULES/shared/components/Forms";
import { toOptions } from "LIB/forms";
import { updateQcStatus } from "MODULES/PurchaseOrders/actions";
import { QC_STATUS_TYPES } from "MODULES/Receiving/constants";

function Form(props) {
  return (
    <AppForm {...props}>
      <AppForm.Body>
        <div className="row row-col-gutters-half">
          <div className="col-md-12">
            <div className="form-group">
              <Field
                name="qc_status"
                component={Select}
                options={toOptions(QC_STATUS_TYPES)}
                label="QC Status"
                required
              />
            </div>
          </div>
        </div>
      </AppForm.Body>
    </AppForm>
  );
}

Form.propTypes = {
  referenceNumber: PropTypes.string.isRequired
};

export default connect(undefined, { onSubmit: updateQcStatus })(
  form({
    form: "updateQCStatus"
  })(Form)
);



// WEBPACK FOOTER //
// ./app/modules/PurchaseOrders/components/Detail/UpdateQcStatus/Form.jsx